import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsPillarsContent } from '../utils/insightsContent';

export const useInsightsPillarsContent = () =>
  useInsightsSectionContent(parseInsightsPillarsContent);
